import { create } from 'zustand';

const today = new Date();

export type DatePeriod = 'day' | 'week' | 'month';

export interface StartDateStoreState {
  activeTab: DatePeriod;
  startDate: Date;
  today: Date;
}

interface StartDateStoreActions {
  setTab: (tab: 'day' | 'week' | 'month') => void;
  setDate: (date: Date) => void;
}

interface StartDateStore {
  state: StartDateStoreState;
  actions: StartDateStoreActions;
}

export const useStartDateStore = create<StartDateStore>((set) => ({
  state: { activeTab: 'day', today: today, startDate: today },
  actions: {
    setTab: (tab: 'day' | 'week' | 'month') =>
      set((state) => ({ state: { ...state.state, activeTab: tab } })),
    setDate: (date: Date) => {
      if (!date) {
        return set((state) => ({
          state: { ...state.state, startDate: today },
        }));
      } else {
        return set((state) => ({ state: { ...state.state, startDate: date } }));
      }
    },
  },
}));
